import React from "react";
import { Typography } from "antd";

type Props = {
  hotKey: string;
  children: React.ReactNode;
}

const HotKey = ({
  hotKey,
  children,
}: Props) => {
  return (
    <div
      style={{
        gap: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {children}

      <Typography.Text
        type="secondary"
        style={{ fontSize: 12, marginRight: -8 }}
      >
        <kbd>{hotKey}</kbd>
      </Typography.Text>
    </div>
  );
};

export default HotKey;
